import './ProfileFollowers.styles.scss';
import { Avatar, Link } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import React, { useContext, useEffect, useState } from 'react';
import { BulletList } from 'react-content-loader';
import MyThemeContext from '../../../contexts/theme-context/ThemeProviderContext';
import pickBkgClass from '../../../utils/pickBkgClass';
import pickSkeletonColor from '../../../utils/pickSkeletonColor';
import Axios from 'axios';
const ProfileFollowers = ({ fetchedUser }) => {
	const { themeName, themeType } = useContext(MyThemeContext);
	const [fetchingFollowers, setFetchingFollowers] = useState(true);
	const [fetchedFollowers, setFetchedFollowers] = useState([]);

	const sleep = ms => new Promise(r => setTimeout(r, ms));
	// followers effect
	useEffect(() => {
		const cancelTokenSource = Axios.CancelToken.source();
		if (fetchedUser.profileUsername) {
			const fetchUserFollowers = async () => {
				setFetchingFollowers(true);
				await sleep(400);
				setFetchedFollowers([]);

				try {
					const response = await Axios.get(
						`/profile/${fetchedUser.profileUsername}/followers`,
						{
							cancelToken: cancelTokenSource.token
						}
					);
					console.log('Fetched user Followers', response);
					setFetchingFollowers(false);
					setFetchedFollowers(response.data);
				} catch (e) {
					if (Axios.isCancel(e)) {
						console.log('Cought cancel');
					} else {
						throw e;
					}
				}
			};
			fetchUserFollowers();
		}
		// cleanup
		return () => {
			cancelTokenSource.cancel();
		};
	}, [fetchedUser.profileUsername]);

	const renderFollowers = () => {
		if (fetchedFollowers.length > 0 && !fetchingFollowers) {
			return (
				<div
					className={`profileFollowers profilePanel  ${pickBkgClass(
						themeName,
						'soft'
					)}`}
				>
					{fetchedFollowers.map(({ avatar, username }, index) => (
						<div className={`avatar_link ${themeType}`} key={index}>
							<Avatar
								component={RouterLink}
								to={`/profile/${username}`}
								src={avatar ? avatar : null}
							/>
							<Link
								className="username"
								color="primary"
								component={RouterLink}
								to={`/profile/${username}`}
							>
								{username}
							</Link>
						</div>
					))}
				</div>
			);
		} else if (fetchedFollowers.length === 0 && fetchingFollowers) {
			return <BulletList width="50vw" {...pickSkeletonColor(themeName)} />;
		} else if (fetchedFollowers.length === 0 && !fetchingFollowers) {
			return (
				<div
					className={`profileFollowers profilePanel  ${pickBkgClass(
						themeName,
						'soft'
					)}`}
				>
					No Followers
				</div>
			);
		}
	};

	return renderFollowers();
};

export default ProfileFollowers;
